class BaseError extends Error {
  state = {};
  displayName;
  prefix;
  errorMessage;
  parent;
  messages = [];
  code;
  constructor(_message, _code, _prefix) {
    const message = _message ? ` ${_message}` : "";
    const displayName = `[${_prefix}]#${_code}`;
    super(`${displayName}.${message}`);
    this.displayName = displayName;
    this.errorMessage = _message;
    this.prefix = _prefix;
    this.code = _code;
    this.name = displayName;
    Object.defineProperty(this, "message", {
      get: () => {
        return this.getDisplayMessage();
      }
    });
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, BaseError);
    }
  }
  get parentError() {
    const parent = this.parent;
    if (!parent) {
      return null;
    }
    if (this.parent instanceof BaseError) {
      return this.parent;
    }
    const displayName = parent.name ?? "[Unknown Error]";
    return {
      getBreadcrumbs() {
        return [displayName];
      },
      getMessage() {
        return [displayName, parent.message ?? "unknown error message"].join(
          "\n"
        );
      }
    };
  }
  /**
   * Returns formatted error message with breadcrumbs
   */
  getDisplayMessage() {
    const breadcrumbs = this.parentError ? this.getBreadcrumbs() : [];
    return [breadcrumbs.join(" -> "), this.getMessage()].filter((x) => x.trim().length).join("\n");
  }
  /**
   * Returns formatted error message
   */
  getMessage() {
    const state = Object.entries(this.state).reduce((acc, [key, value]) => {
      if (value) {
        acc.push(` \u2013 ${key}: ${value}`);
      }
      return acc;
    }, []).join("\n");
    const messages = this.messages.reduce((acc, _messages) => {
      acc.push(` - ${_messages.join(" ")}`);
      return acc;
    }, []).join("\n");
    const parentError = this.parentError;
    const parentErrorMessage = parentError ? ["", parentError.getMessage(), ""].join("\n") : "";
    const thrownErrorMessage = this.errorMessage ? `${this.displayName}: ${this.errorMessage}` : this.displayName;
    return [parentErrorMessage, thrownErrorMessage, state, messages].filter((x) => x.trim().length).join("\n");
  }
  getBreadcrumbs() {
    const parentError = this.parentError;
    if (!parentError) {
      return [this.displayName];
    }
    return [...parentError.getBreadcrumbs(), this.displayName];
  }
  withParentError(e) {
    this.parent = e;
    return this;
  }
  withMessage(...messages) {
    this.messages.push(messages);
    return this;
  }
}
function createErrorBuilder(factory) {
  return function throwException(code, message = "") {
    const instance = new factory(message, code);
    if (Error.captureStackTrace) {
      Error.captureStackTrace(instance, throwException);
    }
    return instance;
  };
}

var EditorPlatformInternalErrorCode = /* @__PURE__ */ ((EditorPlatformInternalErrorCode2) => {
  EditorPlatformInternalErrorCode2["UnexpectedError"] = "UnexpectedError";
  return EditorPlatformInternalErrorCode2;
})(EditorPlatformInternalErrorCode || {});
class EditorPlatformInternalError extends BaseError {
  state = {};
  constructor(message, code) {
    super(message, code, "Editor Platform Internal Error");
  }
  withHost(host) {
    this.state = { ...this.state, host };
    return this;
  }
}
const createEditorPlatformInternalError = createErrorBuilder(EditorPlatformInternalError);

export { BaseError, EditorPlatformInternalErrorCode, createEditorPlatformInternalError, createErrorBuilder };
//# sourceMappingURL=index.mjs.map
